/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { PatientKioskService } from '../../../../icemedx-lib/src/services/patientkiosk/patientkiosk.service'
import { AppService } from '../app.service';

@Component({
  selector: 'app-reasonforadmission',
  templateUrl: './reasonforadmission.component.html',
  styleUrls: ['./reasonforadmission.component.scss'],
  providers: [IcepanelService]
})
export class ReasonforadmissionComponent implements OnInit {

  @Input() onBackButtonClick: Function = (settings) => {
    this.router.navigate([this.appsvc.getBaseRoutePath('fullprofile')]);
  };

  @Input() onSubmitClick: Function = (settings) => {
    this.router.navigate([this.appsvc.getBaseRoutePath('registrationcomplete')]);
  };

  providers: Observable<any[]>;
  inboxSettings: IcepanelcontainerSettings = null;

  constructor(public router: Router, private appsvc: AppService, public patientKioskService: PatientKioskService) { }

  ngOnInit() {
    let panelTag = "ReasonForAdmission";
    let panelKey = Iceutility.guid(false);

    this.providers = <Observable<Array<any>>>this.patientKioskService.getAllProviders();

    let controls: IcecontrolSettings[] = [
      new IcecontrolSettings("icelabel", { value: "Please Enter your doctors name and reason for visit.", width: "100%", color: "red", hasFullWidthContainer: true }, null, null),
      new IcecontrolSettings("iceautocomplete", { placeholder: "Search provider", value: this.providers }, null, null),
      new IcecontrolSettings("icetextarea", { placeholder: "Reason for visit", value: null, width: "50%", height: "150px", hasFullWidthContainer: true }, null, null),
      new IcecontrolSettings("icebutton", { text: "Back", class: ["btn-danger"], glyphClass: "fa-plus-circle" }, null, { onClick: this.onBackButtonClick }),
      new IcecontrolSettings("icebutton", { text: "Submit", class: ["btn-danger"], glyphClass: "fa-plus-circle" }, null, { onClick: this.onSubmitClick }),
    ];

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings(
        "InboxSection",
        {
          class: ["yalla"],
          styles: {
            width: "100%"
          }
        },
        null,
        controls,
        null)
    ];
    let panels: IcepanelSettings[] = [
      new IcepanelSettings(panelTag, panelKey, "Patient Kiosk - Reason for Visit or Admission", "", sections)];

    let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
    this.inboxSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
  }

}
